import React, { useEffect, useState } from 'react';
import { Car, BellRing, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';
import { subscribeAcc } from '../../lib/accTracker';
import { fmtKm } from './AccTrips';

export const ACC_OVERDUE_MIN = 120;
const fmtClock = (iso) => (iso ? new Date(iso).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : '');
const fmtElapsed = (min) => (min >= 60 ? `${Math.floor(min / 60)} h ${String(min % 60).padStart(2, '0')}` : `${min} min`);

/**
 * Bandeau global « accompagnement en cours » : rappel discret, puis alerte au-delà de 2 h sans « ACC fin »
 * (la notification push est envoyée par le serveur ; jamais d'arrêt automatique).
 */
export function AccBanner({ onOpenPlanning }) {
  const [acc, setAcc] = useState({ session: null, km: 0 });
  const [, tick] = useState(0);
  useEffect(() => subscribeAcc(setAcc), []);
  useEffect(() => { const t = setInterval(() => tick((n) => n + 1), 60000); return () => clearInterval(t); }, []);
  const s = acc.session;
  if (!s) return null;
  const elapsedMin = Math.max(0, Math.floor((Date.now() - new Date(s.started_at).getTime()) / 60000));
  const overdue = elapsedMin >= ACC_OVERDUE_MIN;
  return (
    <div className={`rounded-xl border px-3 py-2.5 text-sm mb-4 ${overdue ? 'border-destructive/50 bg-destructive/10' : 'border-[hsl(var(--accent))]/50 bg-[hsl(var(--accent))]/10'}`} role={overdue ? 'alert' : 'status'} data-testid="easer-acc-banner" data-overdue={overdue ? '1' : '0'}>
      <div className="flex items-start gap-2">
        {overdue ? <BellRing className="h-4 w-4 mt-0.5 text-destructive flex-shrink-0 animate-pulse" /> : <Car className="h-4 w-4 mt-0.5 text-[hsl(var(--accent))] flex-shrink-0" />}
        <div className="min-w-0 flex-1">
          <p className="font-semibold">Accompagnement en cours depuis {fmtClock(s.started_at)} ({fmtElapsed(elapsedMin)}){s.client_name ? ` · ${s.client_name}` : ''} · {fmtKm(acc.km)}</p>
          {overdue
            ? <p className="text-destructive font-medium" data-testid="easer-acc-overdue">Plus de 2 h sans « ACC fin » : si le trajet est terminé, arrêtez l'accompagnement depuis le créneau pour que les kilomètres soient justes.</p>
            : <p className="text-muted-foreground">Le trajet est enregistré par GPS. Appuyez sur « ACC fin » sur le créneau quand l'accompagnement est terminé.</p>}
        </div>
      </div>
      {onOpenPlanning && (
        <Button variant="outline" size="sm" onClick={onOpenPlanning} className="mt-2 h-9 w-full" data-testid="easer-acc-banner-open">Ouvrir le créneau <ChevronRight className="h-4 w-4 ml-1" /></Button>
      )}
    </div>
  );
}
